import {GoogleAnalytics} from "../vendors";
import make from "./base";


export default make(GoogleAnalytics.event);
